export default {
  tabSE: 'DeliveryPortal Sweden',
  tabFI: 'DeliveryPortal Finland',
  tabs: {
    all: 'All',
    starred: 'Starred',
  },
  table: {
    ifsCol: 'IFS',
    nameCol: 'Project name',
    shaftCol: 'Excavation',
    hPCol: 'HP',
    versionCol: 'Version',
    statusCol: 'Lastest version status',
    published: 'Published',
    notPublished: 'Not published',
    noProjects: 'No projects were found, please try again.',
    noStarredProjects: 'You do not have any starred projects.',
    searchPlacerholder: 'IFS, project name',
    completeProject: 'Complete project',
  },
  informationBox: 'Table data consists of Completed / Planned',
  modal: {
    projectCompleted: 'Project completed!',
    projectCompletion: 'Project completion',
    ok: 'OK',
    completeProject: 'Complete project',
    cancel: 'Cancel',
    warningText: {
      1: 'All external users will be removed from this project.',
      2: 'Additionally, signed plot designs and landowner details will be deleted after one (1) year.',
      3: 'Are you sure you want to complete this project?',
    },
    confirmCheckboxLabel:
      'I am sure, and confirm that signed plot designs are uploaded to Sharepoint.',
    loading: 'Completing project. Please wait...',
    completedInfo:
      'All external users have been removed from this project. Signed plot designs and landowner details will be deleted after one (1) year!',
  },
  title: 'Delivery Overview',
};
